<template>
	<a href="https://www.feriavalencia.com/" target="_blank" class="pl-1 text-decoration-none info--text">{{ $t('login.forgotpassword') }}</a>
</template>

<script>
export default {};
</script>

<style></style>
